"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var AdtFlagConstructorParser_1 = require("../../core/model/data-dictionary/parsers/AdtFlagConstructorParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var WindowItemWarningFlag_1 = require("../../window/model/WindowItemWarningFlag");
/**
 * Generic version of WindowItemValidationRequest, which probably can be removed.
 * Holds information about desired window item validation.
 *
 * @author Jan Prokop
 */


var ValidationRequest =
/*#__PURE__*/
function () {
  /**
   * @param hint Hint used in validation
   * @param instantErrors list of flags ( window item warning tag ) that are automatically evaluated as instant errors
   */
  function ValidationRequest(hint) {
    var instantErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : immutable_1.List();

    _classCallCheck(this, ValidationRequest);

    this.hint = hint;
    this.instantErrors = instantErrors;
  }

  _createClass(ValidationRequest, null, [{
    key: "getSchema",
    value: function getSchema(hintEnum) {
      var builder = new StructPropBuilder_1.StructPropBuilder(ValidationRequest.name);
      return {
        hint: builder.senum('hint', hintEnum, ''),
        instantErrors: builder.listOf(builder.custom('instantErrors', new AdtFlagConstructorParser_1.AdtFlagConstructorParser(WindowItemWarningFlag_1.WindowItemWarningFlag)))
      };
    }
  }]);

  return ValidationRequest;
}();

exports.ValidationRequest = ValidationRequest;